import { type ForwardRefExoticComponent, Fragment, forwardRef } from 'react';

import { Slottable } from '../slot';
import { MediaObjectContent } from './media-object-content';
import { MediaObjectMedia } from './media-object-media';
import { MediaObjectRoot } from './media-object-root';
import type { MediaObjectPropsInterface } from './types/media-object.types';

/**
 * @since 7.6.0
 */
export const MediaObject = forwardRef<HTMLDivElement, MediaObjectPropsInterface>(
  (props: MediaObjectPropsInterface, forwardedRef) => {
    const { asChild = false, children, media, ...rest } = props;

    return (
      <MediaObject.Root ref={forwardedRef} asChild={asChild} {...rest}>
        <Slottable child={children}>
          {(slottable) => (
            <Fragment>
              <MediaObject.Media>{media}</MediaObject.Media>
              <MediaObject.Content>{slottable}</MediaObject.Content>
            </Fragment>
          )}
        </Slottable>
      </MediaObject.Root>
    );
  },
) as ForwardRefExoticComponent<MediaObjectPropsInterface> & {
  Root: typeof MediaObjectRoot;
  Media: typeof MediaObjectMedia;
  Content: typeof MediaObjectContent;
};

MediaObject.displayName = 'MediaObject';

MediaObject.Root = MediaObjectRoot;
MediaObject.Media = MediaObjectMedia;
MediaObject.Content = MediaObjectContent;
